import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "percentile-value",
  templateUrl: "./percentile-value.component.html",
})
export class PercentileValueComponent implements OnInit {
  @Input() percentile: String | Number;
  @Input() textRight: boolean;
  constructor() {}

  ngOnInit() {}
}
